import { lazy } from 'solid-js'
import { messages } from '../../pages/join-page/join-page-routing.messages.en.js'

// TENANT-5533: the conference QR code resolves here. Not a page in its own
// right — it hands the browser to Core signup at once — so it is `noIndex`
// and deliberately absent from the sitemap.
export default {
    component: lazy(() => import('../../pages/join-page/join-page.jsx')),
    noIndex: true,
    path: '/join',
    showFooter: false,
    showHeader: false,
    titleMessage: messages.titleMessage,
}
